import { Checkbox, TableCell, TableRow } from "@material-ui/core";
import React from "react";

const PermissionNode = ({ node, selectedPermissions, onToggle, level = 0 }) => {
  const getAllChildIds = (node) => {
    let ids = [];

    if (node.children && node.children.length) {
      node.children.forEach((child) => {
        ids.push(child._id);
        ids = [...ids, ...getAllChildIds(child)];
      });
    }

    return ids;
  };

  const childIds = getAllChildIds(node);

  const selectedChildCount = childIds.filter((id) =>
    selectedPermissions.includes(id),
  ).length;

  const someChildrenSelected =
    selectedChildCount > 0 && selectedChildCount < childIds.length;

  const isSelected = selectedPermissions.includes(node._id);
  return (
    <>
      <TableRow>
        <TableCell style={{ paddingTop: 0, paddingBottom: 0 }}>
          <Checkbox
            checked={isSelected}
            indeterminate={!isSelected && someChildrenSelected}
            onChange={() => onToggle(node)}
          />
        </TableCell>

        <TableCell
          style={{
            paddingLeft: `${level * 30}px`,
            paddingTop: 0,
            paddingBottom: 0,
          }}
        >
          {node.title}
        </TableCell>

        <TableCell
          style={{
            paddingLeft: `${level * 30}px`,
            paddingTop: 0,
            paddingBottom: 0,
          }}
        >
          {node.showInSidebar ? "Sidebar" : "Page"}
        </TableCell>

        <TableCell
          style={{
            paddingTop: 0,
            paddingBottom: 0,
          }}
        >
          {node.type}
        </TableCell>
      </TableRow>
      {node.children &&
        node.children?.map((child) => (
          <PermissionNode
            key={child._id}
            node={child}
            selectedPermissions={selectedPermissions}
            onToggle={onToggle}
            level={level + 1}
          />
        ))}
    </>
  );
};

export default PermissionNode;
